<template>
  <form class="form-modal-dialog">
    <validation-provider name="Set name" v-slot="{ errors }" rules="required|max:50">
      <b-field label="Set name"
               ref="setNameField"
               class="field-set-name"
               custom-class="custom-class-field-set-name"
               maxlength="50"
               :type="{ 'is-danger': errors.length }"
               :message="errors + [ '&nbsp;' ]">
        <b-input :value="value"
                 @input.native="$emit('input', $event.target.value)"
                 @blur="blur"
                 maxlength="50"></b-input>
      </b-field>
    </validation-provider>
    <div class="lead-sources-counter-wrapper">
      <span>
        Lead sources ({{changeCheckedRows.length}})
      </span>
      <span v-if="isNoOneLeadSourceSelected" class="is-danger">
        - at least one lead source must be selected
      </span>
    </div>
    <b-table :data="data"
             :height="300"
             :header-checkable="false"
             :mobile-cards="false"
             class="bordered-table"
             :row-class="(row, index) => {
               return `${!leadDistributionSet
               ? (row.leadDistributionSet?'row-custom-background':'')
               :(row.leadDistributionSet?(row.leadDistributionSet.id
                !== leadDistributionSet.id?'row-custom-background':''):'')}`
             }"
             :checked-rows.sync="changeCheckedRows"
             checkbox-position="left"
             v-slot="props"
             ref="leadSources"
             checkable>
      <b-table-column cell-class="cell" field="value">
        <div class="lead-distribution-set-title-wrapper">
          <span class="lead-distribution-set-title">{{ props.row.value }}</span>
        </div>
        <div v-if="props.row.leadDistributionSet">
              <span v-if="!leadDistributionSet
              || (leadDistributionSet
                  && (props.row.leadDistributionSet.id !== leadDistributionSet.id)
                  )" class="span-used-distribution-set">
                {{props.row.leadDistributionSet.title}}
              </span>
        </div>
      </b-table-column>
    </b-table>
  </form>
</template>

<script>

export default {
  name: 'LeadDistributionSet',
  props: {
    value: {},
    blur: {},
    checkedRows: {
    },
    leadDistributionSet: {
      type: Object,
      default: () => {},
    },
    data: {
      type: Array,
      default: () => [],
    },
    row: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    changeCheckedRows: {
      get() {
        return this.arrayOfCheckedRows;
      },
      set(val) {
        this.arrayOfCheckedRows = val;
        this.isNoOneLeadSourceSelected = false;
        this.$emit('checking-row', val);
        return val;
      },
    },
  },
  data() {
    return {
      arrayOfCheckedRows: this.checkedRows,
      isNoOneLeadSourceSelected: false,
    };
  },
  mounted() {
    const htmlTableRows = document.querySelectorAll('td.checkbox-cell label.b-checkbox');
    htmlTableRows.forEach((item) => {
      item.addEventListener('keydown', (event) => {
        if (event.code === 'Space') {
          event.preventDefault();
          const eventClick = new Event('click', { bubbles: true, cancelable: true });
          item.dispatchEvent(eventClick);
        }
      });
    });
  },
  methods: {
  },
};
</script>

<style scoped lang="stylus">
.field-set-name
  margin-bottom 20px
.form-modal-dialog >>> .field-set-name
  .custom-class-field-set-name
    font-weight 400
.lead-sources-counter-wrapper
  margin-bottom 10px
.bordered-table
  td:first-child
    border-left 1px solid rgba(143, 167, 179, 0.3)
  td:last-child
    border-right 1px solid rgba(143, 167, 179, 0.3)
    background-color unset
    flex-wrap wrap
    column-gap 5px
    justify-content end!important
    .lead-distribution-set-title
      font-size 16px
    .lead-distribution-set-title-wrapper
      white-space normal
.bordered-table >>> table.table thead
  display none
.bordered-table >>> td.checkbox-cell
  border-left 1px solid rgba(143,167,179,0.3)

.bordered-table >>> tr.row-custom-background
  background-color #F2F2F2!important
.span-used-distribution-set
  color #525F66
.is-checked .span-used-distribution-set
  text-decoration line-through
.b-table >>> tbody tr.is-checked
  td.checkbox-cell label.b-checkbox.checkbox span.check
    border-color #47c68d
    background #47c68d url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:%23fff' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E") no-repeat center center
.is-danger
  color #DE4B4B
.b-table >>> tbody tr td.checkbox-cell label.b-checkbox.checkbox:hover span.check
  border-color #47c68d
.b-table >>> tbody tr:first-child td
  border-top 1px solid rgba(143,167,179,0.3)
</style>
